import classNames from 'classnames/bind';
import Icon, { IconTheme, IconVariant } from 'src/components/ui-kit/icon/icon';
import { DetailedHTMLProps, SelectHTMLAttributes } from 'react';
import styles from './form.module.scss';
import FormError from './_error';
import { getError, getValue, onBlur } from './_text-input';
import { FormikProps, FormikValues } from 'formik';

const classesContext = classNames.bind(styles);

export type FormSelectOption = {
  label: string;
  value: number | string;
};

export type FormSelectInputProps<T = FormikValues> = DetailedHTMLProps<
  SelectHTMLAttributes<HTMLSelectElement>,
  HTMLSelectElement
> & {
  formik?: FormikProps<T>;
  isAsteriskShown?: boolean;
  isLockShown?: boolean;
  isBordered?: boolean;
  options: Array<FormSelectOption>;
  isLoading?: boolean;
};

export default function FormSelect<T>({
  formik,
  name,
  isLockShown,
  isAsteriskShown,
  isBordered,
  className,
  options,
  placeholder,
  ...inputProps
}: FormSelectInputProps<T>): JSX.Element {
  const error = getError<T>(formik, name);

  return (
    <div
      className={classesContext([
        'form_group',
        'form_group__select',
        {
          form_group__required: isAsteriskShown,
          form_group__bordered: isBordered,
          form_group__error: error
        },
        className
      ])}
    >
      <div className={styles.form_group_selecticon}>
        <Icon
          variant={IconVariant.DROPDOWN}
          theme={IconTheme.GRAY} />
      </div>
      <select
        onChange={formik?.handleChange}
        onBlur={() => onBlur(formik, name)}
        name={name}
        value={getValue<T>(formik, name)}
        className={classesContext(['form_control', 'select', { select_notchoose: !getValue<T>(formik, name) }])}
        {...inputProps}
      >
        {placeholder && (
          <option
            value=''
            className={styles.select_notchoose}>
            {placeholder}
          </option>
        )}
        {options.map((item) => (
          <option
            className={styles.select_item}
            key={item.value}
            value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
      {isLockShown && (
        <span className={styles.form_group__disabled}>
          <Icon variant={IconVariant.LOCK} />
        </span>
      )}
      {error && <FormError error={error} />}
    </div>
  );
}
